import { useState } from 'react';

import Card from '../../../components/Card';
import Table from '../../../components/Table';
import Loading from '../../../components/Loading';
import { formatDisplayNumber } from '../../../utils/format';
import Modal from '../../../components/Modal';
import TopCompanyLabel from '../../../components/TopCompanyLabel';

import { top8ValueSectorHeads } from '../Dashboard.columns';
import {
  transferTop8TradingValueBySectorData,
  getTop10TooltipContent,
  tradingPeriod,
} from '../Dashboard.helpers';
import * as Styles from '../Dashboard.styles';

const SectorItem = ({
  sector,
  total,
  isDarkMode,
  tooltipPosition,
  onChartIconClick,
  handleTooltipOpen,
  top8ChartData,
  number,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark,
}) => {
  return (
    <Card className="block sector-item">
      <h4 className="text-sm flex items-center">
        <img
          alt={sector.name}
          src={`/images/numbers/${number}.png`}
          className="mr-2.5 float-left w-10"
        />
        <span className="inline-block">
          {sector.name}
          <span className="block font-bold mt-1">
            {formatDisplayNumber(
              parseFloat((Number(sector.gtgd) / 1000).toFixed(2))
            )}
            tỷ (
            {sector.gtgd != 0
              ? parseFloat(((Number(sector.gtgd) * 100) / total).toFixed(2))
              : 0}
            %)
          </span>
        </span>
      </h4>
      <div className="mt-2 border-solid border-t-[1px]">
        <Table
          rows={transferTop8TradingValueBySectorData(
            sector.companies,
            Number(sector.gtgd),
            isDarkMode,
            tooltipPosition,
            onChartIconClick,
            handleTooltipOpen,
            top8ChartData,
            isInvestmentCategoriesLoading,
            authenticated,
            investmentCategories,
            followCompanies,
            saveInvestmentCategory,
            deleteInvestmentCategory,
            investmentCategoriesMessage,
            isOpeningBookmark,
            handleSetIsOpeningBookmark
          )}
          headCells={top8ValueSectorHeads}
          noBorderStyle
          className="small-spacing"
        />
      </div>
    </Card>
  );
};

const Top8ValueSector = ({
  isLoading,
  data,
  isDarkMode,
  handleTooltipOpen,
  top8ChartData,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark,
  setSelectedChartPeriod,
  handlesSelectedChartPeriodChange,
  selectedChartPeriod,
  setSelectedDataChartModal,
  setChartModalShow,
  isChartDataByCodeLoading,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelectedCode] = useState('');
  const [companyInfo, setCompanyInfo] = useState(null);
  const [field, setField] = useState('klgd');

  const newData = [...data];
  const total = newData.reduce((total, item) => total + Number(item.gtgd), 0);

  const onChartIconClick = (code, info) => {
    setChartModalShow(true);
    setSelectedDataChartModal({
      code,
      field,
    });
    setOpen(true);
    setSelectedCode(code);
    setCompanyInfo(info);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedDataChartModal({
      code: '',
      field: '',
    });
    setChartModalShow(false);
    setSelectedChartPeriod(tradingPeriod[0].value);
  };

  const getModalTitle = () => {
    return (
      <div className="flex items-center">
        <span>
          Giá & {field === 'gtgd' ? 'GTGD' : 'KLGD'} - {companyInfo?.code}
        </span>
        <TopCompanyLabel label={companyInfo?.label} />
        <span className="pl-1">- {companyInfo?.name}</span>
      </div>
    );
  };

  return (
    <div>
      <div className="mt-3">
        {isLoading ? <Styles.EmptyTag /> : null}
        <Loading isLoading={isLoading} className="white" />
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mt-6">
          {newData
            ?.sort((a, b) => b.gtgd - a.gtgd)
            ?.slice(0, 12)
            ?.map((sector, index) => (
              <SectorItem
                key={sector.id}
                sector={sector}
                total={total}
                isDarkMode={isDarkMode}
                onChartIconClick={onChartIconClick}
                handleTooltipOpen={handleTooltipOpen}
                top8ChartData={top8ChartData}
                number={index + 1}
                isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
                authenticated={authenticated}
                investmentCategories={investmentCategories}
                followCompanies={followCompanies}
                saveInvestmentCategory={saveInvestmentCategory}
                deleteInvestmentCategory={deleteInvestmentCategory}
                investmentCategoriesMessage={investmentCategoriesMessage}
                isOpeningBookmark={isOpeningBookmark}
                handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
              />
            ))}
        </div>
      </div>
      <Modal
        isOpen={open}
        onCloseModal={handleCloseModal}
        title={getModalTitle()}
        mainContentClassName="modal-center max-w-[96vw] md:max-w-[70vw] m-auto w-full"
        childrenWrapperClassName=""
      >
        <div className="w-full main-content">
          {selectedCode
            ? getTop10TooltipContent(
                top8ChartData,
                field,
                selectedCode,
                field === 'gtgd' ? 'GTGD' : 'KLGD',
                field === 'gtgd' ? ' tỷ' : 'cp',
                isDarkMode,
                'modal',
                '350px',
                70,
                handlesSelectedChartPeriodChange,
                selectedChartPeriod,
                setField,
                isChartDataByCodeLoading
              )
            : null}
        </div>
      </Modal>
    </div>
  );
};

export default Top8ValueSector;
